<div class="inner-content">
    <ion-grid>
        <ion-row *ngIf="mobileConfiguration && mobileConfiguration.mobilehireHealthCareInUse === 1">
            <ion-item (click)="selectCurrentCustomer()">
                <ion-label>
                    <h2>Current
                        Hospital: {{configuration.currentCustomer ? configuration.currentCustomer.name : 'Tap to select current Hospital'}}</h2>
                </ion-label>
            </ion-item>
        </ion-row>

        <ion-row *ngIf="mobileConfiguration.mobilehireHealthCareInUse === 1">
            <ion-col size="12" class="ion-text-center" (click)="scanBarcode(3)">
                <div class="border ion-align-items-center">
                    <div class="ion-align-items-center">
                        <ion-icon size="large" slot="icon-only" name="barcode"
                                  class="ion-align-self-center"></ion-icon>
                    </div>
                    <div lines="none" class="ion-no-padding ion-no-margin ion-align-items-center">
                        <ion-label class="ion-text-center">
                            <p>Buffer Stock Reconciliation</p>
                        </ion-label>
                    </div>
                </div>
            </ion-col>
        </ion-row>
        <ion-row *ngIf="mobileConfiguration.mobilehireHealthCareInUse === 1">
            <ion-col size="12" class="ion-text-center" (click)="scanBarcode(2)">
                <div class="border ion-align-items-center">
                    <div class="ion-align-items-center">
                        <ion-icon size="large" slot="icon-only" name="barcode"
                                  class="ion-align-self-center"></ion-icon>
                    </div>
                    <div lines="none" class="ion-no-padding ion-no-margin ion-align-items-center">
                        <ion-label class="ion-text-center">
                            <p>Check items in Ward</p>
                        </ion-label>
                    </div>
                </div>
            </ion-col>
        </ion-row>
        <ion-row *ngIf="mobileConfiguration.mobilehireHealthCareInUse === 1">
            <ion-col size="12" class="ion-text-center" (click)="scanBarcode(4)">
                <div class="border ion-align-items-center">
                    <div class="ion-align-items-center">
                        <ion-icon size="large" slot="icon-only" name="barcode"
                                  class="ion-align-self-center"></ion-icon>
                    </div>
                    <div lines="none" class="ion-no-padding ion-no-margin ion-align-items-center">
                        <ion-label class="ion-text-center">
                            <p>Hospital Stock Reconciliation</p>
                        </ion-label>
                    </div>
                </div>
            </ion-col>
        </ion-row>
        <ion-row *ngIf="mobileConfiguration.mobilehireHealthCareInUse === 1">
            <ion-col size="12" class="ion-text-center" (click)="scanBarcode(1)">
                <div class="border ion-align-items-center">
                    <div class="ion-align-items-center">
                        <ion-icon size="large" slot="icon-only" name="barcode"
                                  class="ion-align-self-center"></ion-icon>
                    </div>
                    <div lines="none" class="ion-no-padding ion-no-margin ion-align-items-center">
                        <ion-label class="ion-text-center">
                            <p>Cancelation</p>
                        </ion-label>
                    </div>
                </div>
            </ion-col>
        </ion-row>

        <ion-row>
            <ion-col [size]="docTypes.length >= 4 ? 6 : 12"
                     *ngFor="let type of docTypes" (click)="newDocument(type.id)" class="ion-text-center">
                <div class="border ion-align-items-center">
                    <div class="ion-align-items-center">
                        <ion-icon size="large" slot="icon-only" [icon]="generalServices.setIcon(type.id)"
                                  class="ion-align-self-center"></ion-icon>
                    </div>
                    <div lines="none" class="ion-no-padding ion-no-margin ion-align-items-center">
                        <ion-label class="ion-text-center">
                            <p>{{type.description}}</p>
                        </ion-label>
                    </div>
                </div>
            </ion-col>
        </ion-row>

    </ion-grid>
    <ion-button expand="full" shape="round" (click)="modalController.dismiss()" color="danger"
                class="ion-padding-horizontal">
        Cancel
    </ion-button>
</div>
